module.exports = __webpack_public_path__ + "img/img22.2e4a69ed.svg";